import { AlertCircle, ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { LaunchPlayer } from "@/components/LaunchPlayer";
import { useLaunch } from "@/lib/useLaunches";

/** One launch film in the branded player. */
export function LaunchPage() {
  const { videoId } = useParams<{ videoId: string }>();
  const { data, isLoading, isError, error } = useLaunch(videoId);

  return (
    <div className="flex flex-col gap-6">
      <Link to="/launches" className="flex w-fit items-center gap-1.5 font-sans text-sm font-semibold text-bw-navy hover:underline">
        <ArrowLeft className="h-4 w-4" aria-hidden /> All launches
      </Link>

      {isLoading && <p className="font-sans text-sm text-bw-ink-muted">Loading…</p>}

      {isError && (
        <div className="flex items-center gap-2 rounded-card border border-bw-blue-muted/40 p-4 font-sans text-sm text-bw-ink-muted">
          <AlertCircle className="h-4 w-4 shrink-0 text-bw-blue" aria-hidden />
          {Number(error?.status) === 404 ? "There's no launch film at this address." : "Couldn't load this film. Try again shortly."}
        </div>
      )}

      {data && (
        <>
          <LaunchPlayer src={data.video_url} poster={data.poster_url} title={data.title} />
          <section className="flex flex-col gap-2">
            <h1 className="text-3xl font-bold text-bw-navy">{data.title}</h1>
            <p className="max-w-3xl font-sans text-base text-bw-ink-muted">{data.summary}</p>
            {data.published_at && (
              <p className="font-sans text-xs text-bw-ink-muted">
                Published {new Date(data.published_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
                {data.created_by ? ` by ${data.created_by}` : ""}
                {data.cost_usd != null && ` · about $${data.cost_usd.toFixed(2)} in provider costs`}
              </p>
            )}
          </section>
        </>
      )}
    </div>
  );
}
